<template>
  <div class="addProject">
    <el-dialog
      :visible.sync="dialog.visible"
      :show-close=false
      :before-close="handleClose">
      <div class="title">{{title}}</div>
      <split></split>
      <div class="form_body">
        <el-form ref="schedule_form" :model="form" label-width="0">
          <el-form-item class="project_name">
            <el-input
              v-model="form.team_name"
              placeholder="项目名称">
            </el-input>
          </el-form-item>
          <split></split>
            <el-form-item class="project_remark">
              <el-input
                v-model="form.introduction"
                placeholder="备注">
              </el-input>
            </el-form-item>
          <split></split>
          <div class="form_buttons">
            <el-button class="cancel_btn" @click.stop="closeAddProjectDialog">取消</el-button>
            <el-button v-if="dialog.method === 'add'" class="confirm_btn" type="primary" @click.stop="addProjectSubmit" :class="{disableBtn: isDisable}">完成<i class="icon iconfont icon-fabu2"></i></el-button>
            <el-button v-if="dialog.method === 'edit'" class="confirm_btn" type="primary" @click.stop="editProjectSubmit" :class="{disableBtn: isDisable}">完成<i class="icon iconfont icon-fabu2"></i></el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
   <!-- <div class="cover"></div>
    <div class="dialog">
      <div class="title">添加日程</div>
      <div class="content"></div>
    </div>-->
  </div>
</template>

<script type="text/ecmascript-6">
import split from './split_line_2px.vue'
import { mapState } from 'vuex'
import axios from 'axios'
export default {
  name: 'addProject',
  components: {
    split
  },
  props: {
    addProjectDialogVisible: false,
    projecttype: {
      method: '',
      team_no: ''
    }
  },
  data: function () {
    return {
      form: {
        user_no: this.$store.state.userInfo.user_no,
        team_name: '',
        introduction: '',
        team_no: ''
      },
      title: '',
      dialog: {
        visible: false,
        method: '',
        no: ''
      }
    }
  },
  methods: {
    handleClose () {
      console.log('handle dialog close')
    },
    addProjectSubmit () {
      if (this.isDisable) {
        console.log('isDisable')
        return
      }
      let _this = this
      axios({
        method: 'post',
        url: _this.HOST + '/company/addTeam',
        params: _this.form
      }).then(res => {
        let data = res.data
        console.log('创建项目')
        console.log(data)
        if (data.statusCode === 200) {
          _this.$store.dispatch('setProjectList')
          _this.cleanFormData()
          _this.closeAddProjectDialog()
        } else {
          console.log(data.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    editProjectSubmit () {
      if (this.isDisable) {
        console.log('isDisable')
        return
      }
      let _this = this
      axios({
        method: 'post',
        url: _this.HOST + '/company/updateTeam',
        params: _this.form
      }).then(res => {
        let data = res.data
        console.log('创建项目')
        console.log(data)
        if (data.statusCode === 200) {
          _this.$store.dispatch('setProjectList')
          _this.cleanFormData()
          _this.closeAddProjectDialog()
        } else {
          console.log(data.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    cleanFormData () {
      this.form.team_name = ''
      this.form.introduction = ''
      this.form.team_no = ''
    },
    closeAddProjectDialog () {
      this.cleanFormData()
      let data = {
        visible: false,
        method: '',
        no: ''
      }
      this.$store.dispatch('setProjectDialog', data)
    }
  },
  computed: {
    ...mapState([
      'projectDialog'
    ]),
    isDisable () {
      return this.form.team_name === ''
    }
  },
  watch: {
    projectDialog: {
      handler (newVal, oldVal) {
        let _this = this
        this.dialog.visible = newVal.visible
        this.dialog.method = newVal.method
        this.dialog.no = newVal.no
        let method = newVal.method
        let teamNo = newVal.no
        this.form.team_no = teamNo
        if (method === 'edit') {
          _this.title = '编辑项目'
          axios({
            method: 'get',
            url: _this.HOST + '/company/getTeamDetail',
            params: {
              team_no: teamNo
            }
          }).then((res) => {
            let data = res.data
            console.log('项目详情')
            console.log(data)
            if (data.statusCode === 200) {
              let team = data.data
              _this.form.team_name = team.team_name
              _this.form.introduction = team.introduction
            } else {
              console.log(data.message)
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.title = '添加项目'
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  // .addSchedule
  //   .cover
  //     position fixed
  //     top 0
  //     left 0
  //     width 100%
  //     height 100%
  //     background rgba(0, 0, 0, 0.7)
  //     z-index 30
  //   .dialog
  //     position fixed
  //     top: 10%
  //     left 35%
  //     width 33.75rem
  //     height 40.625rem
  //     z-index 50
  //     border-radius 0.125rem
  //     box-shadow 0 0.0625rem 0.1875rem $tinGrey
  //     background $white
  .addProject
    .el-dialog
      width 23.625rem
      .el-dialog__header
        display none
      .el-dialog__body
        padding 0 1.25rem 1rem 1.25rem
        .title
          height 3.4375rem
          line-height 3.4375rem
          text-align center
          font-size 1.125rem
          font-weight 500
        .form_body
          .form_buttons
            text-align right
            margin 1rem 0 0 0
            .el-button--medium
              padding 6px 11px
              font-size 16px
              i
                margin-left 5px
                font-size 16px
            .cancel_btn
              border none
              outline none
              background transparent
          .el-form-item.type_form_item
            margin-bottom 1rem
          .el-form-item
            margin-bottom 0
            .el-form-item__content
              display flex
              .label_icon
                flex 1
                font-size 1rem
                font-weight 900
                color $lightGrey
              .date_picker,.sub_title,.el-select,.el-input
                flex 7
                input
                  height 2.5rem
                  width 100%
                  padding 0
                  border none
              .sub_title_2
                flex 13
              .takeplace
                flex 6
              .el-textarea
                textarea
                  height 9.0625rem
                  padding 0.31256rem
                  border none
                  outline none
                  resize none
              .el-input__prefix,.el-input__suffix
                display none
              .el-radio-button
                margin-right 2rem
                .el-radio-button__inner
                  width 1.875rem
                  height 1.875rem
                  padding 0
                  border-radius 50%
                  outline none
                  font-size 0.625rem
                  line-height 1.875rem
                  text-align center

</style>



// WEBPACK FOOTER //
// src/pagesPc/others/dialogProject.vue